// PageLoader.js
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const PageLoader = ({ size = "default", tip = null }) => {
  const fontSize = size === "small" ? 24 : size === "large" ? 80 : 60;
  const antIcon = <LoadingOutlined style={{ fontSize }} spin />;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "10px",
      }}
    >
      <Spin indicator={antIcon} tip={tip} />
    </div>
  );
};

export default PageLoader;
